import React, { FC, memo, useCallback, useContext } from 'react'

import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { Container, OfferWrapper, SliderContainer, StyledCarouselProvider, StyledSlider } from './styles'
import GridCard from '../common/grid-card'
import { CtaButtonText, CtaContainer, StyledGhostButton, Subtitle, Title, TitleContainer } from '../common/styles'
import { useTranslation } from '../../../hooks/locale'
import { ScreenContext } from 'react-components'
import { Slide } from 'pure-react-carousel'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { useResponsiveMobileSlides } from '../hooks'

interface Props {
    topOfferListingsSection: ListingSectionTransport
    url: string
    breadcrumbList?: BreadcrumbListTransport
}

const TopOffersSection: FC<Props> = ({ topOfferListingsSection, url, breadcrumbList }) => {
    const { t } = useTranslation()
    const { isTablet, isDesktop } = useContext(ScreenContext)

    const _handleViewAllAccommodationsClick = useCallback(() => {
        document.location.href = topOfferListingsSection.cta?.url || url
    }, [url])

    const topOfferListings = topOfferListingsSection.objects
    const mobileVisibleSlides = useResponsiveMobileSlides({ smallMobile: 1.5, defaultMobile: 1.75 })

    return (
        <Container id="top-offers">
            <TitleContainer>
                <Title>{topOfferListingsSection.heading}</Title>
                <Subtitle>{topOfferListingsSection.subheading}</Subtitle>
            </TitleContainer>
            {isDesktop ? (
                <OfferWrapper>
                    {topOfferListings.map((recommendedObject, index) => (
                        <GridCard
                            key={recommendedObject.id}
                            listingObject={recommendedObject}
                            position={index}
                            breadcrumbList={breadcrumbList}
                            requestUrl={url}
                        />
                    ))}
                </OfferWrapper>
            ) : (
                <SliderContainer>
                    <StyledCarouselProvider
                        totalSlides={topOfferListings.length}
                        visibleSlides={isTablet ? 2.4 : mobileVisibleSlides}
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        isIntrinsicHeight
                        lockOnWindowScroll
                        dragStep={1}
                        center
                    >
                        <StyledSlider $transitionTime={0.2}>
                            {topOfferListings.map((recommendedObject, index) => (
                                <Slide index={recommendedObject.id} key={`${index}_${recommendedObject.id}`}>
                                    <GridCard
                                        key={recommendedObject.id}
                                        listingObject={recommendedObject}
                                        position={index}
                                        requestUrl={url}
                                    />
                                </Slide>
                            ))}
                        </StyledSlider>
                    </StyledCarouselProvider>
                </SliderContainer>
            )}
            {topOfferListingsSection.cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={() => _handleViewAllAccommodationsClick()} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Container>
    )
}

export default memo(TopOffersSection)
